import { StyleTypeContext } from "../../../umbilical_tools";
import _ from "lodash";
import React, { useContext } from "react";
import { createUseStyles } from "react-jss";
import { PropTypes } from "prop-types";
import jssVariables from "../../../jss_setup";

const overlayStyles = createUseStyles({
  overlay: (props) => ({
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: jssVariables.colors.background.dark,
    zIndex: 1083,
    ...props.extraStyles,
    ..._.get(props, "customStyles.overlay", {}),
  }),
});
export const Overlay = ({ extraStyles }) => {
  const { type, brand, cStyler } = useContext(StyleTypeContext);
  const classes = overlayStyles({
    customStyles: cStyler({
      type,
      brand,
      objName: "overlay",
    }),
    extraStyles,
  });

  return <div className={classes.overlay} />;
};
Overlay.defaultProps = {
  extraStyles: {},
};
Overlay.propTypes = {
  extraStyles: PropTypes.object,
};
